<div class="d-flex flex-column gap-3 categories">
  <app-layer-config-collapsible-category
    description="Source"
    storageKey="customer-source"
    [collapsedDefault]="false"
    class="pb-2"
  >
    <!-- icon="hierarchy-checkmark" -->
    <app-layer-control-item
      description="RCS Data"
      [isLayerVisibile]="isPartialDfrsVisible"
      [layerId]="DataSource.RcsData.name"
      icon="car-check-multi-point"
      (visibilityToggled)="toggleLayerVisbility($event)"
    ></app-layer-control-item>
    <app-layer-control-item
      description="DFRS Data"
      [isLayerVisibile]="isOnlyDfrsVisible"
      [layerId]="DataSource.DfrsData.name"
      icon="core-data"
      (visibilityToggled)="toggleLayerVisbility($event)"
    ></app-layer-control-item>
    <ng-container
      *hasPermissionAny="[Permissions.RCS_Apps_Simulation_Access, Permissions.RCS_Apps_All]"
    >
      <app-layer-control-item
        class="simulation-toggle"
        description="Show Simulations"
        [isLayerVisibile]="isSimulationVisible"
        [layerId]="Layers.SimWarning.name"
        icon="plan-floorplan-edit"
        (visibilityToggled)="toggleLayerVisbility($event)"
        [isDisabled]="isHistoryVisible"
        data-cy="customer-simulation-toggle"
      ></app-layer-control-item>
    </ng-container>
  </app-layer-config-collapsible-category>
  <app-layer-config-collapsible-category
    description="Warnings"
    storageKey="customer-warnings"
    [collapsedDefault]="false"
  >
    <app-layer-control-item
      description="Accidents"
      [isLayerVisibile]="isVALayerVisible"
      [layerId]="Layers.VAWarning.name"
      icon="car-crash"
      (visibilityToggled)="toggleLayerVisbility($event)"
      *hasPermissionAny="Layers.VAWarning.permissions"
    ></app-layer-control-item>
    <app-layer-control-item
      description="BDV"
      [isLayerVisibile]="isBDVLayerVisible"
      [layerId]="Layers.BDVWarning.name"
      icon="car-mechanic"
      (visibilityToggled)="toggleLayerVisbility($event)"
      *hasPermissionAny="Layers.BDVWarning.permissions"
    ></app-layer-control-item>
    <app-layer-control-item
      description="Traction Loss"
      [isLayerVisibile]="isTLLayerVisible"
      [layerId]="Layers.TLWarning.name"
      icon="wheel-vehicle"
      (visibilityToggled)="toggleLayerVisbility($event)"
      *hasPermissionAny="Layers.TLWarning.permissions"
    ></app-layer-control-item>
    <app-layer-control-item
      description="Construction Sites"
      [isLayerVisibile]="isCSLayerVisible"
      [layerId]="Layers.CSWarning.name"
      icon="construction"
      (visibilityToggled)="toggleLayerVisbility($event)"
      *hasPermissionAny="Layers.CSWarning.permissions"
    ></app-layer-control-item>
    <app-layer-control-item
      description="Low Visibility"
      [isLayerVisibile]="isLVLayerVisible"
      [layerId]="Layers.LVWarning.name"
      icon="weather-mist"
      (visibilityToggled)="toggleLayerVisbility($event)"
      *hasPermissionAny="Layers.LVWarning.permissions"
    ></app-layer-control-item>
    <app-layer-control-item
      description="Heavy Rain"
      [isLayerVisibile]="isHRLayerVisible"
      [layerId]="Layers.HRWarning.name"
      icon="weather-rain-warning"
      (visibilityToggled)="toggleLayerVisbility($event)"
      *hasPermissionAny="Layers.HRWarning.permissions"
    ></app-layer-control-item>
    <app-layer-control-item
      description="Heavy Snow"
      [isLayerVisibile]="isHSLayerVisible"
      [layerId]="Layers.HSWarning.name"
      icon="ice"
      (visibilityToggled)="toggleLayerVisbility($event)"
      *hasPermissionAny="Layers.HSWarning.permissions"
    ></app-layer-control-item>
    <app-layer-control-item
      description="Strong Wind"
      [isLayerVisibile]="isSWLayerVisible"
      [layerId]="Layers.SWWarning.name"
      icon="wind-vane-moderate"
      (visibilityToggled)="toggleLayerVisbility($event)"
      *hasPermissionAny="Layers.SWWarning.permissions"
    ></app-layer-control-item>
    <app-layer-control-item
      description="Poor Road"
      [isLayerVisibile]="isPRLayerVisible"
      [layerId]="Layers.PRWarning.name"
      icon="mold"
      (visibilityToggled)="toggleLayerVisbility($event)"
      *hasPermissionAny="Layers.PRWarning.permissions"
    ></app-layer-control-item>
    <app-layer-control-item
      description="Wrong Way Driver"
      [isLayerVisibile]="isWWDLayerVisible"
      [layerId]="Layers.WWDWarning.name"
      icon="user-hand-stop"
      (visibilityToggled)="toggleLayerVisbility($event)"
      *hasPermissionAny="Layers.WWDWarning.permissions"
    ></app-layer-control-item>
    <app-layer-control-item
      description="Item on Road"
      [isLayerVisibile]="isIORLayerVisible"
      [layerId]="Layers.IORWarning.name"
      icon="truck-box"
      (visibilityToggled)="toggleLayerVisbility($event)"
      *hasPermissionAny="Layers.IORWarning.permissions"
    ></app-layer-control-item>
    <app-layer-control-item
      description="Amber light"
      [isLayerVisibile]="isALLayerVisible"
      [layerId]="Layers.ALWarning.name"
      icon="emergency-front"
      (visibilityToggled)="toggleLayerVisbility($event)"
      *hasPermissionAny="Layers.ALWarning.permissions"
    ></app-layer-control-item>
    <app-layer-control-item
      description="Blue light"
      [isLayerVisibile]="isBLLayerVisible"
      [layerId]="Layers.BLWarning.name"
      icon="siren"
      (visibilityToggled)="toggleLayerVisbility($event)"
      *hasPermissionAny="Layers.BLWarning.permissions"
    ></app-layer-control-item>
    <app-layer-control-item
      description="Stopped Vehicle"
      [isLayerVisibile]="isSVLayerVisible"
      [layerId]="Layers.SVWarning.name"
      icon="car"
      (visibilityToggled)="toggleLayerVisbility($event)"
      *hasPermissionAny="Layers.SVWarning.permissions"
    ></app-layer-control-item>
    <app-layer-control-item
      description="Traffic Jam"
      [isLayerVisibile]="isTJTLayerVisible"
      [layerId]="Layers.TJTWarning.name"
      icon="cars-traffic"
      (visibilityToggled)="toggleLayerVisbility($event)"
      *hasPermissionAny="Layers.TJTWarning.permissions"
    ></app-layer-control-item>
  </app-layer-config-collapsible-category>
</div>
